import {
    CREATE_SCHOOL_REQUEST,
    CREATE_SCHOOL_SUCCESS,
    CREATE_SCHOOL_FAILURE,
    READ_SCHOOL_REQUEST,
    READ_SCHOOL_SUCCESS,
    READ_SCHOOL_FAILURE,
    UPDATE_SCHOOL_REQUEST,
    UPDATE_SCHOOL_SUCCESS,
    UPDATE_SCHOOL_FAILURE,
    DELETE_SCHOOL_REQUEST,
    DELETE_SCHOOL_SUCCESS,
    DELETE_SCHOOL_FAILURE
  } from '../actions/schoolActionTypes';
  
  const initialState = {
    schools: [],
    loading: false,
    error: null,
  };
  
  const schoolReducer = (state = initialState, action) => {
    switch (action.type) {
      // Create School
      case CREATE_SCHOOL_REQUEST:
        return { ...state, loading: true, error: null };
      case CREATE_SCHOOL_SUCCESS:
        return { ...state, loading: false, schools: [...state.schools, action.payload], error: null };
      case CREATE_SCHOOL_FAILURE:
        return { ...state, loading: false, error: action.error };
  
      // Read Schools
      case READ_SCHOOL_REQUEST:
        return { ...state, loading: true, error: null };
      case READ_SCHOOL_SUCCESS:
        return { ...state, loading: false, schools: action.payload, error: null };
      case READ_SCHOOL_FAILURE:
        return { ...state, loading: false, error: action.error };
  
      // Update School
      case UPDATE_SCHOOL_REQUEST:
        return { ...state, loading: true, error: null };
      case UPDATE_SCHOOL_SUCCESS:
        return {
          ...state,
          loading: false,
          schools: state.schools.map((school) =>
            school.school_id === action.payload.school_id ? action.payload : school
          ),
          error: null,
        };
      case UPDATE_SCHOOL_FAILURE:
        return { ...state, loading: false, error: action.error };
  
      // Delete School
      case DELETE_SCHOOL_REQUEST:
        return { ...state, loading: true, error: null };
      case DELETE_SCHOOL_SUCCESS:
        return {
          ...state,
          loading: false,
          schools: state.schools.filter((school) => school.school_id !== action.payload),
          error: null,
        };
      case DELETE_SCHOOL_FAILURE:
        return { ...state, loading: false, error: action.error };
  
      default:
        return state;
    }
  };
  
  export default schoolReducer;
  